import IntlMessages from '@iso/components/utility/intlMessages';
import React from 'react';

const orderStatuses = new Map(
  Object.entries({
    created: <IntlMessages id="order.status.created" />,
    accepted: <IntlMessages id="order.status.accepted" />,
    cooking: <IntlMessages id="order.status.cooking" />,
    ready: <IntlMessages id="order.status.ready" />,
    on_the_way: <IntlMessages id="order.status.onTheWay" />,
    delivered: <IntlMessages id="order.status.delivered" />,
    picked_up: <IntlMessages id="order.status.pickedUp" />,
    restaurant_cancelled: (
      <IntlMessages id="order.status.restaurantCancelled" />
    ),
    customer_cancelled: <IntlMessages id="order.status.customerCancelled" />,
  })
);

const orderAggregators = new Map(
  Object.entries({
    3: 'Website',
    4: 'Dine-in',
    5: 'GrubHub',
    //19: 'Localbytes',
    //20: 'Telegram',
    25: 'UberEats',
    26: 'Doordash',
    27: 'Postmates',
    //28: 'Seamless',
    //1: 'DeliveryClub',
    //2: 'YandexEda',
  })
);

const orderTypes = new Map(
  Object.entries({
    delivery: <IntlMessages id="finReport.text.delivery" />,
    pickup: <IntlMessages id="productSettings.item.menuType.pickup" />,
    marketplace: (
      <IntlMessages id="integrations.sectionTitle.courierServices" />
    ),
    owncouriers: <IntlMessages id="integrations.sectionTitle.ownCouriers" />,
    // waiter: <IntlMessages id="restaurantSettings.tabs.waiter" />,
  })
);

const filtersName = new Map(
  Object.entries({
    aggregator_id: <IntlMessages id="reports.filters.aggregator" />,
    brand_id: <IntlMessages id="reports.filters.brand" />,
    date_start: <IntlMessages id="reports.filters.dateStart" />,
    delivery: <IntlMessages id="reports.filters.delivery" />,
    order_id: <IntlMessages id="reports.filters.order" />,
    order_status: <IntlMessages id="reports.filters.orderStatus" />,
    restaurant_id: <IntlMessages id="reports.filters.restaurant" />,
  })
);

const timesOfOrders = new Map(
  Object.entries({
    1: <IntlMessages id="filterCRMData.one" />,
    2: <IntlMessages id="filterCRMData.two" />,
    3: <IntlMessages id="filterCRMData.three" />,
    4: <IntlMessages id="filterCRMData.four" />,
    5: <IntlMessages id="filterCRMData.five" />,
    6: <IntlMessages id="filterCRMData.six" />,
    7: <IntlMessages id="filterCRMData.seven" />,
    8: <IntlMessages id="filterCRMData.eight" />,
    9: <IntlMessages id="filterCRMData.nine" />,
    10: <IntlMessages id="filterCRMData.ten" />,
  })
);

const lastMonthOrders = new Map(
  Object.entries({
    30: <IntlMessages id="filterCRMData.oneMonths" />,
    60: <IntlMessages id="filterCRMData.twoMonths" />,
    90: <IntlMessages id="filterCRMData.threeMonths" />,
  })
);

/** DoorDash uses aggregator ids 26 and 6 in DB; include both when either is filtered. */
const DOORDASH_AGGREGATOR_IDS = ['26', '6'];

const DIRECT_DEFAULT_AGGREGATOR_IDS = ['3'];

const MARKETPLACE_DEFAULT_AGGREGATOR_IDS = ['4', '5', '25', '26', '27'];

function expandAggregatorIdsForApi(aggregatorIds) {
  if (aggregatorIds == null) return aggregatorIds;
  if (!Array.isArray(aggregatorIds)) return aggregatorIds;
  const out = aggregatorIds.map((id) => String(id));
  const hasDoorDash = out.includes('26') || out.includes('6');
  if (!hasDoorDash) return out;
  if (!out.includes('26')) out.push('26');
  if (!out.includes('6')) out.push('6');
  return out;
}

/** Collapse legacy DoorDash id 6 into 26 for filter UI (one Doordash option). */
function aggregatorIdsForUi(aggregatorIds) {
  if (aggregatorIds == null) return aggregatorIds;
  if (!Array.isArray(aggregatorIds)) return aggregatorIds;
  let ids = [...new Set(aggregatorIds.map((id) => String(id)))];
  if (ids.includes('6')) {
    ids = ids.filter((id) => id !== '6');
    if (!ids.includes('26')) ids.push('26');
  }
  return ids;
}

function normalizeMarketplaceAggregatorIds(aggregatorIds) {
  if (aggregatorIds == null) return MARKETPLACE_DEFAULT_AGGREGATOR_IDS;
  if (!Array.isArray(aggregatorIds) || aggregatorIds.length === 0) {
    return MARKETPLACE_DEFAULT_AGGREGATOR_IDS;
  }
  return aggregatorIdsForUi(aggregatorIds);
}

export {
  orderStatuses,
  orderAggregators,
  orderTypes,
  filtersName,
  timesOfOrders,
  lastMonthOrders,
  DOORDASH_AGGREGATOR_IDS,
  DIRECT_DEFAULT_AGGREGATOR_IDS,
  MARKETPLACE_DEFAULT_AGGREGATOR_IDS,
  expandAggregatorIdsForApi,
  aggregatorIdsForUi,
  normalizeMarketplaceAggregatorIds,
};
